import React, {Component} from 'react'

import {Layout, Dropdown, Menu, Avatar, Popover} from 'antd';
import { withRouter} from 'react-router-dom'
import {Aside} from '../../components'
import {loginOutRequest,getUserDetail} from '../../request'
import {envHttpUrl} from '../../http/globalMethod'

import {
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    DownOutlined,
    LogoutOutlined,
    DeploymentUnitOutlined,
    UserOutlined
} from '@ant-design/icons';
import * as Icon from "@ant-design/icons";
const { Header, Content } = Layout;
const  locationQuery = new URLSearchParams(window.location.search)
const iFrameParam = locationQuery.get('iframe')
class Frame extends Component {
    state = {
        collapsed: false,
        clientWidth:document.body.clientWidth,
        userInfo: null,
    };
    toggle = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    };
    componentDidMount() {
        window.addEventListener('resize', () => {
            this.setState({
                clientWidth:document.body.clientWidth
            })
        });
        getUserDetail({}).then(res => {
            this.setState({ userInfo: res })
        }).catch(() => {})
    }
    goProfile = (tab) => {
        this.props.history.push(`/portal/profile?tab=${tab || 'info'}`)
    }
    render() {
        const { userInfo } = this.state
        const userMenu = (
            <Menu>
                <Menu.Item key="info" icon={<UserOutlined />} onClick={() => this.goProfile('info')}>
                    个人中心
                </Menu.Item>
                <Menu.Item key="apikey" icon={<Icon.KeyOutlined />} onClick={() => this.goProfile('apikey')}>
                    我的 API Key
                </Menu.Item>
                <Menu.Item key="log" icon={<Icon.FileTextOutlined />} onClick={() => this.goProfile('log')}>
                    调用日志
                </Menu.Item>
            </Menu>
        )
        return (
            <Layout hasSider={false}>
                {
                    iFrameParam!='iframe'?
                        <Header className="site-layout-background header-section" >
                            <div className="logo-wrap">
                                {
                                    this.state.clientWidth>=500?
                                        React.createElement(this.state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                                            className: 'trigger',
                                            onClick: this.toggle,
                                        }):
                                        <Popover placement={'rightTop'} content={
                                            <Aside sys={this.props.sys} sysLink={this.props.sysLink} collapsed={this.state.collapsed}/>
                                        }>
                                            <Icon.MenuOutlined className={'trigger'}/>
                                        </Popover>
                                }
                                {/*{React.createElement(this.state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {*/}
                                {/*    className: 'trigger',*/}
                                {/*    onClick: this.toggle,*/}
                                {/*})}*/}
                                <div className="logo">{this.props.title}</div>

                            </div>
                            <div className="header-user-wrap">
                                <Dropdown overlay={userMenu} placement="bottomRight" trigger={['click']}>
                                    <span className="header-user-info" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}>
                                        <Avatar
                                            size={28}
                                            src={userInfo?.avatar}
                                            icon={<UserOutlined />}
                                            style={{ background: '#1890ff' }}
                                        />
                                        <span style={{ color: '#333', fontSize: 13 }}>{userInfo?.userNick || userInfo?.nickName || ''}</span>
                                        <DownOutlined style={{ color: '#333', fontSize: 11 }} />
                                    </span>
                                </Dropdown>
                            </div>
                        </Header>
                        :''
                }
                <Layout className="site-layout">
                    {
                        iFrameParam!='iframe'?
                            this.state.clientWidth>=500?
                                <Aside sys={this.props.sys} sysLink={this.props.sysLink} collapsed={this.state.collapsed}/>
                                :''
                            :''
                    }
                    <Content
                        className="site-layout-background"
                        style={{
                            margin: '9px',
                            minHeight: 280,
                            overflowY:'scroll'
                        }}>
                        {this.props.children}

                    </Content>
                </Layout>
            </Layout>
        )
    }
}
export default withRouter(Frame)